export const HttpAccessType = {
  Company: "company",
  Anonymous: "anonymous",
  Internal: "internal",
  Admin: "admin",
  Master: "master",
  Unknown: "unknown",
} as const;

export type HttpAccessType =
  (typeof HttpAccessType)[keyof typeof HttpAccessType];

export const HttpHeader = {
  AccessType: "x-access-type",
  TraceId: "x-trace-id",
  RequestId: "x-request-id",
  UserId: "x-user-id",
  CompanyId: "x-company-id",
  Email: "x-email",
  CustomPermissions: "x-custom-permissions",
  BuiltinRoles: "x-builtin-roles",
  ForwardedFor: "x-forwarded-for",
  TaskExecutionId: "x-task-execution-id",
  CallerService: "x-caller-service",
  SessionId: "x-session-id",
  UserAgent: "x-user-agent",
  IsSuperAdmin: "x-is-super-admin",
  ApiKeyId: "x-api-key-id",
} as const;
